import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { Hotel } from 'frontend-utils/models';
import type { Pmsdatasource, Pmsintegration, Pmsversion } from 'lumen/models';

export interface EligibilityQuestionAnswer {
  answers: string[];
  name: string;
}

export default class Otbselfservice extends Model {
  [Type] = 'otbselfservice' as const;

  @belongsTo('pmsdatasource', { async: false, inverse: null })
  declare otherSystem: Pmsdatasource;

  @belongsTo('pmsdatasource', { async: false, inverse: null })
  declare pmsDatasource: Pmsdatasource;

  @belongsTo('pmsintegration', { async: false, inverse: null })
  declare pmsIntegration: Pmsintegration;

  @belongsTo('pmsversion', { async: false, inverse: null })
  declare pmsVersion: Pmsversion;

  @belongsTo('hotel', { async: false, inverse: null })
  declare subscription: Hotel;

  @attr('string') declare customOtherSystemName: string;
  @attr declare eligibilityQuestionsAnswers: EligibilityQuestionAnswer[];
  // @ts-expect-error: No overload matches this call.
  @attr('boolean', { allowNull: true }) declare futureResearchCandidate:
    | boolean
    | null;

  @attr('string') declare otherPmsName: string;
  @attr
  declare otherSystemEligibilityQuestionsAnswers: EligibilityQuestionAnswer[];

  @attr declare setupStepsAnswers: unknown;
  @attr('string') declare stage: string;
  // @ts-expect-error: No overload matches this call.
  @attr('boolean', { allowNull: true }) declare wantsToSeeBenchmark:
    | boolean
    | null;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get pmsDisplayName() {
    return this.otherPmsName || this.pmsVersion?.displayName;
  }
}
